import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que saber cocinar?',
    a: 'No, las 50 recetas son ultra sencillas y rápidas.'
  }, {
    q: '¿Es caro?',
    a: 'No, son ingredientes que ya conoces, pero usados con estrategia renal.'
  }, {
    q: '¿Interfiere con mis medicinas?',
    a: 'Es 100% nutricional, por lo que apoya y no sustituye tu tratamiento médico.'
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-205">
      <div className="max-w-3xl mx-auto" data-id="element-206">
        <FadeIn data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-forest" data-id="element-208">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-6" data-id="element-209">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-210">
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-211">
                  {faq.q}
                </h3>
                <p className="text-lg text-gray-600" data-id="element-212">{faq.a}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}